<template>
  <WizardStep
    v-if="hasEditMerchantSettingsPermission"
    @submit="submit"
    @reset="reset"
  >
    <template v-slot:content>
      <div class="company-settings">
        <div class="brand-logo">
          <BrandingSettings
            v-if="hasSetLogoPermission || hasSetBannerPermission"
          ></BrandingSettings>
        </div>
        <div class="company-container">
          <div class="company">
            <div class="row">
              <div class="col-xl ">
                <div class="form-group setting-container">
                  <label>Business Name</label>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.merchant.name.$model"
                    :state="validateState('name')"
                    placeholder="Business Name"
                  />
                  <div v-if="!$v.merchant.name.required">
                    Name is required
                  </div>
                  <div v-if="!$v.merchant.name.minLength">
                    Name must have at least
                    {{ $v.merchant.name.$params.minLength.min }} letters.
                  </div>
                </div>
                <div class="form-group setting-container">
                  <label>Slogan</label>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.merchant.slogan.$model"
                    :state="validateState('slogan')"
                    placeholder="Slogan"
                  />
                </div>
                <div class="form-group setting-container">
                  <label>Email Address</label>
                  <b-form-input
                    type="email"
                    class="form-control"
                    v-model.trim="$v.merchant.email.$model"
                    :state="validateState('email')"
                    placeholder="Company Email Address"
                  />
                  <div v-if="!$v.merchant.email.required">
                    Email address is required
                  </div>
                </div>

                <div class="form-group setting-container">
                  <label>Email Display Name</label>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.merchant.emailDisplayName.$model"
                    :state="validateState('emailDisplayName')"
                    placeholder="Company Email Display Name"
                  />
                </div>
                <div class="form-group setting-container">
                  <label>Telephone</label>
                  <b-form-input
                    type="tel"
                    class="form-control"
                    v-model.trim="$v.merchant.phoneNumber.$model"
                    :state="validateState('phoneNumber')"
                    placeholder="Company Phone Number"
                    v-mask="'(###) ###-####'"
                  />
                  <div v-if="!$v.merchant.phoneNumber.required">
                    A phone number is required
                  </div>
                </div>

                <div class="form-group setting-container">
                  <label>Address Line 1</label>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.merchant.location.streetAddress1.$model"
                    :state="validateState('location.streetAddress1')"
                    placeholder="Address"
                  />
                  <div v-if="!$v.merchant.location.streetAddress1.required">
                    Address is required
                  </div>
                </div>

                <div class="form-group setting-container">
                  <label>Address Line 2</label>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.merchant.location.streetAddress2.$model"
                    :state="validateState('location.streetAddress2')"
                    placeholder="Address"
                  />
                </div>

                <div class="form-group setting-container">
                  <label>Country:</label>
                  <b-form-select
                    v-model="merchant.location.countryName"
                    :value="merchant.location.countryName"
                    :state="validateState('location.countryName')"
                    :options="countries"
                    class="form-control"
                  >
                    <template v-slot:first>
                      <b-form-select-option selected disabled :value="null">
                        -- Select a Country --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                  <div v-if="!$v.merchant.location.countryName.required">
                    Country is required
                  </div>
                </div>

                <div class="form-group setting-container">
                  <label>City</label>
                  <b-form-select
                    class="form-control"
                    v-model.trim="$v.merchant.location.stateName.$model"
                    :value="merchant.location.stateName"
                    :state="validateState('location.stateName')"
                    :options="cities"
                    :disabled="cities.length < 1"
                    placeholder="City"
                  >
                    <template v-slot:first>
                      <b-form-select-option selected disabled :value="null">
                        -- Select a City --
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                  <div v-if="!$v.merchant.location.stateName.required">
                    City is required
                  </div>
                </div>

                <div class="form-group setting-container">
                  <label>Tax ID</label>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.merchant.taxId.$model"
                    :state="validateState('taxId')"
                    placeholder="Company Tax ID"
                  />
                  <!-- <div v-if="!$v.merchant.phoneNumber.required">
                  A phone number is required
                </div> -->
                </div>
                <div class="form-group setting-container">
                  <label>Business Hours</label>
                  <b-form-input
                    type="text"
                    class="form-control"
                    v-model.trim="$v.merchant.businessHours.$model"
                    :state="validateState('businessHours')"
                    placeholder="Company Business Hours"
                  />
                  <!-- <div v-if="!$v.merchant.phoneNumber.required">
                  A phone number is required
                </div> -->
                </div>
                <div class="setting-container cbox">
                  <b-checkbox
                    style="padding-left: 0;"
                    v-model="$v.merchant.enableReceiptEmails.$model"
                    size="lg"
                    >Enable Receipt Emails</b-checkbox
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </WizardStep>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import { mask } from "vue-the-mask";
import { required, minLength, email } from "vuelidate/lib/validators";
import BrandingSettings from "./BrandingSettings.vue";
import MerchantSettingsPermissionsMixin from "@/components/merchantsettings/MerchantSettingsPermissionsMixin.js";
//import LogoUploadSettings from "@/components/widgets/LogoUploadSettings";

export default {
  mixins: [MerchantSettingsPermissionsMixin],

  components: { WizardStep /*LogoUploadSettings*/, BrandingSettings },
  directives: { mask },
  data: () => {
    return {
      appropriateMutation: "",
      countries: [],
      cities: [],
      merchant: {
        name: null,
        slogan: null,
        phoneNumber: null,
        enableReceiptEmails: true,
        email: null,
        emailDisplayName: null,
        taxId: null,
        businessHours: null,
        location: {
          streetAddress1: null,
          streetAddress2: null,
          countryName: null,
          stateName: null
        }
      }
    };
  },
  validations: {
    merchant: {
      name: {
        required,
        minLength: minLength(4)
      },
      slogan: {
        // required
      },
      enableReceiptEmails: {},
      emailDisplayName: {},
      taxId: {},
      businessHours: {},
      email: {
        email,
        required
      },
      phoneNumber: {
        required
      },
      location: {
        countryName: {
          required
        },
        streetAddress1: {
          required
        },
        streetAddress2: {},
        stateName: {
          required
        }
      }
    }
  },
  methods: {
    async setMutation() {
      var result = await this.getMerchant();
      this.appropriateMutation = result ? "updateMerchant" : "addMerchant";
    },
    async getMerchant() {
      return (
        await this.gqlQuery("getMerchant", {
          params: {
            merchant_code: await this.getMerchantId()
          }
        })
      ).data.getMerchant;
    },
    async submit() {
      if (!this.hasEditMerchantSettingsPermission) return;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
      } else {
        this.submitStatus = "PENDING";
        await this.setMutation();
        this.merchant.aliasCode = await this.getMerchantId();
        var result = await this.mutation(this.appropriateMutation, {
          body: {
            merchant: this.merchant
          }
        });
        if (result.data[this.appropriateMutation])
          this.$bvToast.toast("Saved Successfully", {
            title: "Company Settings",
            autoHideDelay: 5000,
            variant: "success",
            append: true
          });
        else {
          this.$bvToast.toast("An error occurred while saving", {
            title: "Company Settings",
            autoHideDelay: 5000,
            variant: "danger",
            append: true
          });
        }
        this.submitStatus = "OK";
      }
    },

    async reset() {
      var merchant = await this.getMerchant();

      if (merchant && merchant.name && merchant.location) {
        this.merchant = merchant;
        this.$bvToast.toast("Changes Cancelled", {
          title: "Company Settings",
          autoHideDelay: 5000,
          variant: "success",
          append: true
        });
      }
    },
    validateState(name) {
      const childPorperty = name.includes(".");

      if (!childPorperty) {
        const { $dirty, $error } = this.$v.merchant[name];
        return $dirty ? !$error : null;
      } else {
        const property = name.split(".");
        const { $dirty, $error } = this.$v.merchant[property[0]][property[1]];
        return $dirty ? !$error : null;
      }
    }
  },
  computed: {
    selectedCountry() {
      return this.merchant.location.countryName;
    }
  },
  watch: {
    async selectedCountry(value) {
      this.cities = (
        await this.gqlQuery("getMerchantCountry", {
          params: {
            country_name: encodeURI(value)
          }
        })
      ).data.getMerchantCountry.states.map(s => s.name);
    }
  },
  async created() {
    try {
      this.countries = (
        await this.gqlQuery("getAllMerchantCountries")
      ).data.getAllMerchantCountries.map(c => c.name);
    } catch (error) {
      this.$logger.error(error);
      this.cities = [];
    }
    var merchant = await this.getMerchant();
    if (merchant && merchant.name && merchant.location)
      this.merchant = merchant;
  }
};
</script>

<style lang="scss" scoped>
.setting-container > label {
  clear: both;
  float: left;
  font-weight: 500 !important;
  font-size: 14px !important;
}
.setting-container {
  display: grid !important;
  grid-template-columns: 2fr 2fr !important;
}
.company-container {
  display: flex;

  flex-direction: row;
}
.company-settings {
  justify-content: space-between;
  display: flex;
}
.cbox {
  font-weight: 400;
  margin: 2rem 0 2rem;
}

@media only screen and (max-width: 1024px) {
  .setting-container {
    display: flex !important;
    flex-direction: column;
  }

  .setting-container > label {
    clear: none;
    float: none;
    font-weight: 500 !important;
    font-size: 14px !important;
  }
  .company-settings {
    flex-direction: column;
  }
  .company-container {
    display: flex;
    justify-content: center;
    flex-direction: row;
  }
}
</style>
